var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var MessageRoundedHint = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 1024 832", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M996.33 215A351.72 351.72 0 0 0 672 0H352A352.12 352.12 0 0 0 38.36 511.94 355.16 355.16 0 0 0 128 623.53V672a32 32 0 0 0 64 0v-64a32 32 0 0 0-12.78-25.58 290.85 290.85 0 0 1-83.87-99.62A288.06 288.06 0 0 1 352 64h320a288 288 0 0 1 203.65 491.65A286.15 286.15 0 0 1 672 640H352a32 32 0 0 0-17.75 5.37l-192 128a32 32 0 0 0 35.5 53.26L361.69 704H672a352.18 352.18 0 0 0 324.33-489z" }),
            React.createElement("path", { className: "cls-1", d: "M512 448a32 32 0 0 0 32-32V192a32 32 0 0 0-64 0v224a32 32 0 0 0 32 32z" }),
            React.createElement("circle", { className: "cls-1", cx: 512, cy: 512, r: 35 }))))); };
export default MessageRoundedHint;
//# sourceMappingURL=MessageRoundedHint.js.map